import { Dropdown, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import receiveicon from "../../../../assets/images/receive-icon.svg";
import adjusticon from "../../../../assets/images/adjust-icon.svg";
import transfericon from "../../../../assets/images/transfer-icon.svg";
import refreshicon from "../../../../assets/images/refresh-icon.svg";
import reporticon from "../../../../assets/images/report-icon.svg";
import repackIcon from "../../../../assets/images/repack-icon.svg";
import countIcon from "../../../../assets/images/count-icon.svg";
import threedotvertical from "../../../../assets/images/three-dots-vertical.svg";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { debounce } from "lodash";
import CommonPagination from "../../../../global/Pagination/CommonPagination";
import useInventory from "../../../../Hooks/useInventory";
import { itemPagesettingName, toggleClass } from "../../../../utils/commonUtils";
import Loading from "../../../../components/LoadingPage/Loading";
import { selectCurrentUserId } from "../../../../redux/auth/authSlice";
import { InventoryReceiveModel } from "./popUpModels/inventoryReceiveModel";
import { InventoryAdjustModel } from "./popUpModels/inventoryAdjustModel";
import { InventoryTransferModel } from "./popUpModels/inventoryTransferModel";
import { useAppSelector } from "../../../../redux/hooks";
import useLocations from "../../../../Hooks/useLocations";
import { InventoryRepackModel } from "./popUpModels/inventoryRepackModel";
import { InventoryCountModel } from "./popUpModels/inventoryCountModel";
import moment from "moment";
import React from "react";
import {
  useModulePermissions,
  PermissionIdentifier,
  PermissionModule,
} from "../../../../utils/permissionUtils";
import useSettings from "../../../../Hooks/useSettings";
export const InventoryManagementTab = ({
  onShowReportModal,
  selectedItem,
  refreshOMTab,
}: any) => {
  const currentUserId = useAppSelector(selectCurrentUserId);
  const [showInventoryReceiveModal, setShowInventoryReceiveModal] = useState(false);
  const [showInventoryRepackModal, setShowInventoryRepackModal] = useState(false);
  const [showInventoryCountModal, setShowInventoryCountModal] = useState(false);
  const [showInventoryAdjustModal, setShowInventoryAdjustModal] = useState(false);
  const [showInventoryTransferModal, setShowInventoryTransferModal] = useState(false);
  const [inventoryTransactionsList, setInventoryTransactionsList] = useState([]);
  const [adjustmentTransactionList, setAdjustmentTransactionList] = useState([]);
  const [locationDropDownVal, setLocationDropDownVal] = useState([]);
  const [inventoryCountList, setInventoryCountList] = useState<any[]>();
  const [activeLocation, setActiveLocation] = useState("");
  const [requiredDecimalPoint, setRequiredDecimalPoint] = useState<number>(2);
  const [inventoryLocationGridPageSize, setInventoryLocationGridPageSize] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [localSearchText, setLocalSearchText] = useState("");
  const [searchText, setSearchText] = useState("");
  const tableWrapperRef = useRef<HTMLDivElement>(null);

  const { getLocationsAPI, getLocationsLoading } = useLocations();
  const { getSettingsAPI, getSettingsLoading } = useSettings();
  const {
    getInventoryCountListAPI,
    getInventoryCountListLoading,
    getInventoryTransactions,
    getInventoryTransactionsLoading,
    inventoryTransAdjust,
    inventoryTransactionsAdjustLoading,
    inventoryTransReceive,
    inventoryTransactionsReceiveLoading,
    inventoryTransTransfer,
    inventoryTransactionsTransferLoading,
    inventoryTransCount,
    inventoryTransactionsCountLoading,
    inventoryTransRepack,
    inventoryTransactionsRepackLoading
  } = useInventory();

  const getInvCountList = () => {
    getInventoryCountListAPI(selectedItem.id).then((res: any) => {
      if (res) {
        setInventoryCountList(res);
        refreshOMTab(res);
      }
    });
  };

  const getSettings = async () => {
    try {
      const res = await getSettingsAPI({ searchText: itemPagesettingName });
      if (res) {
        const settingValue = res[0].settingValue ? JSON.parse(res[0].settingValue) : {};
        setRequiredDecimalPoint(settingValue?.RequiredDecimalPoint ?? 2);
        setInventoryLocationGridPageSize(settingValue?.InventoryLocationGridPageSize ?? null);
      }
    } catch (err: any) {
      console.error("Error while fetching Settings", err);
    }
  }

  const getLocations = async () => {
    try {
      const res = await getLocationsAPI({
        searchText: "",
        includeDeleted: false,
        active: true,
        hasMappedLocation: false,
      });
      if (res) {
        setLocationDropDownVal(
          res?.map((option: any) => {
            return {
              value: option.id,
              label: option.locationName,
            };
          })
        );
      }
    } catch (err: any) {
      console.error("Error while fetching Locations", err);
    }
  };

  const getTransactions = async () => {
    try {
      const res = await getInventoryTransactions();
      if (res) {
        setInventoryTransactionsList(
          res.map((option: any) => {
            return {
              value: option.id,
              label: option.transactionName,
            };
          })
        );
        setAdjustmentTransactionList(
          res
            .filter(
              (option: any) =>
                option.transactionGroup === 1 &&
                option.isDisplayed === true &&
                option.transactionName.toLowerCase() !== "repack in" &&
                option.transactionName.toLowerCase() !== "repack out"
            )
            .map((option: any) => {
              return {
                value: option.id,
                label: option.transactionName,
              };
            })
        );
      }
    } catch (err: any) {
      console.error("Error while fetching Inventory Transactions", err);
    }
  };

  useEffect(() => {
    getInvCountList();
    getSettings();
    getLocations();
    getTransactions();
  }, []);

  const toggleInventoryreceiveModal = () => {
    if (showInventoryReceiveModal) setActiveLocation("");
    toggleClass();
    setShowInventoryReceiveModal(!showInventoryReceiveModal);
  };

  const toggleInventoryrepackModal = () => {
    if (showInventoryRepackModal) setActiveLocation("");
    toggleClass();
    setShowInventoryRepackModal(!showInventoryRepackModal);
  };

  const toggleInventoryCountModal = () => {
    if (showInventoryCountModal) setActiveLocation("");
    toggleClass();
    setShowInventoryCountModal(!showInventoryCountModal);
  };

  const toggleInventoryAdjustModal = () => {
    if (showInventoryAdjustModal) setActiveLocation("");
    toggleClass();
    setShowInventoryAdjustModal(!showInventoryAdjustModal);
  };

  const toggleInventoryTransferModal = () => {
    if (showInventoryTransferModal) setActiveLocation("");
    toggleClass();
    setShowInventoryTransferModal(!showInventoryTransferModal);
  };

  const getTotal = () => {
    let sum = 0;
    inventoryCountList?.forEach((x) => {
      sum = sum + parseFloat(x.quantity);
    });
    return parseFloat(sum.toString()).toFixed(2);
  };

  const invTransAdjust = (values: any) => {
    inventoryTransAdjust(values)
      .then(() => {
        toggleInventoryAdjustModal();
        getInvCountList();
      })
      .catch();
  };

  const invTransReceive = (values: any) => {
    inventoryTransReceive(values)
      .then(() => {
        toggleInventoryreceiveModal();
        getInvCountList();
      })
      .catch();
  };

  const invTransTransfer = (values: any) => {
    inventoryTransTransfer(values)
      .then(() => {
        toggleInventoryTransferModal();
        getInvCountList();
      })
      .catch();
  };

  const invTransCount = (values: any) => {
    inventoryTransCount(values)
      .then(() => {
        toggleInventoryCountModal();
        getInvCountList();
      })
      .catch();
  };

  const invTransRepack = (values: any) => {
    return inventoryTransRepack(values)
      .then((result: any) => {
        getInvCountList();
        return result;
      });
  };

  // Create a debounced version of the search handler
  const debouncedSearch = useMemo(
    () => debounce((value: string) => {
      setSearchText(value);
      setCurrentPage(1);
    }, 500),
    []
  );

  // Handle search input change
  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearchText(value);
    debouncedSearch(value);
  }, [debouncedSearch]);

  // Handle clear search
  const handleClearSearch = useCallback(() => {
    setLocalSearchText("");
    setSearchText("");
    debouncedSearch.cancel();
    setCurrentPage(1);
  }, [debouncedSearch]);

  // Filter by location name
  const filteredList = useMemo(() => {
    if (!inventoryCountList) return [];
    if (!searchText.trim()) return inventoryCountList;
    const searchLower = searchText.trim().toLowerCase();
    return inventoryCountList.filter((item: any) =>
      item.location?.locationName?.toLowerCase().includes(searchLower)
    );
  }, [inventoryCountList, searchText]);

  const paginatedList = useMemo(() => {
    if (!filteredList.length) return [];
    if (!inventoryLocationGridPageSize) return filteredList;
    const startIndex = (currentPage - 1) * inventoryLocationGridPageSize;
    return filteredList.slice(startIndex, startIndex + inventoryLocationGridPageSize);
  }, [filteredList, currentPage, inventoryLocationGridPageSize]);

  const handlePaginationChange = useCallback((page: number) => {
    if (currentPage === page) return;
    setCurrentPage(page);
    tableWrapperRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [currentPage, setCurrentPage]);

  const isPermitted = useModulePermissions(PermissionModule.INVENTORY);
  const isReceivePermitted = isPermitted(PermissionIdentifier.RECEIVE_INVENTORY);
  const isAdjustPermitted = isPermitted(PermissionIdentifier.ADJUST_INVENTORY);
  const isTransferPermitted = isPermitted(PermissionIdentifier.TRANSFER_INVENTORY);
  const isRepackPermitted = isPermitted(PermissionIdentifier.REPACK_INVENTORY);
  const isUpdateCountPermitted = isPermitted(PermissionIdentifier.UPDATE_INVENTORY_COUNT);
  const isViewReportPermitted = isPermitted(PermissionIdentifier.VIEW_INVENTORY_REPORT);

  const isLoading = getInventoryCountListLoading || inventoryTransactionsAdjustLoading || inventoryTransactionsTransferLoading || inventoryTransactionsReceiveLoading || getInventoryTransactionsLoading || inventoryTransactionsCountLoading || getLocationsLoading || getSettingsLoading || inventoryTransactionsRepackLoading;

  return (
    <>
      {isLoading && (<Loading />)}
      <div className="inventory-tab-head" ref={tableWrapperRef}>
        <div className="inventory-tab-search-box">
          <input
            type="text"
            className="form-control inventory-location-search"
            placeholder="Search by location"
            value={localSearchText}
            onChange={handleSearchChange}
          />
          {localSearchText && (
            <span
              className="inventory-search-clear-icon"
              onClick={handleClearSearch}
            >
              <i className="bi bi-x"></i>
            </span>
          )}
        </div>
        <div className="inventory-tab-action-wrapper">
          <div className="inventory-tab-action-box inventory-tab-more-action-wrapper">
            {isReceivePermitted && (
              <div
                className="invt-receive-icon-box"
                onClick={toggleInventoryreceiveModal}
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>Receive</Tooltip>}
                  trigger={["hover", "focus"]}
                >
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={receiveicon}
                  />
                </OverlayTrigger>
              </div>
            )}
            {isAdjustPermitted && (
              <div
                className="invt-adjust-icon-box"
                onClick={toggleInventoryAdjustModal}
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>Adjust</Tooltip>}
                  trigger={["hover", "focus"]}
                >
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={adjusticon}
                  />
                </OverlayTrigger>
              </div>
            )}
            {isTransferPermitted && (
              <div
                className="invt-transfer-icon-box"
                onClick={toggleInventoryTransferModal}
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>Transfer</Tooltip>}
                  trigger={["hover", "focus"]}
                >
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={transfericon}
                  />
                </OverlayTrigger>
              </div>
            )}
            <div
              className="invt-repack-icon-box"
              onClick={toggleInventoryrepackModal}
            >
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip>Repack</Tooltip>}
                trigger={["hover", "focus"]}
              >
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={repackIcon}
                />
              </OverlayTrigger>
            </div>
            <div
              className="invt-count-icon-box"
              onClick={toggleInventoryCountModal}
            >
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip>Count</Tooltip>}
                trigger={["hover", "focus"]}
              >
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={countIcon}
                />
              </OverlayTrigger>
            </div>
            <div className="invt-refresh-icon-box" onClick={getInvCountList}>
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip>Refresh</Tooltip>}
                trigger={["hover", "focus"]}
              >
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={refreshicon}
                />
              </OverlayTrigger>
            </div>
            {isViewReportPermitted && (
              <div className="invt-refresh-icon-box" onClick={onShowReportModal}>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip> Transaction Report</Tooltip>}
                  trigger={["hover", "focus"]}
                >
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={reporticon}
                  />
                </OverlayTrigger>
              </div>
            )}
          </div>
          {/* <div className="inventory-tab-action-box inventory-tab-action-dropdown dropdown">
            <span
              className="dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Actions <i className="bi bi-chevron-down"></i>
            </span>
            <ul className="dropdown-menu">
              {isRepackPermitted && <li onClick={toggleInventoryrepackModal}>Repack</li>}
              {isUpdateCountPermitted && <li onClick={toggleInventoryCountModal}>Count</li>}
            </ul>
          </div> */}
          {/* {isViewReportPermitted && (
            <div
              className="inventory-tab-action-box inventory-tab-action-trans-report"
              onClick={onShowReportModal}
            >
              <ReactSVG className="svg-box" wrapper="span" src={reporticon} />{" "}
              Transaction Report
            </div>
          )} */}
          {/* <div className="inventory-tab-action-box inventory-tab-action-filter">
            <ReactSVG className="svg-box" wrapper="span" src={filtericon} />
          </div> */}
        </div>
      </div>

      <div className="inventory-profile-table-wrapper">
        <Table bordered={false} hover={true} style={{ margin: 0 }}>
          <thead>
            <tr>
              <th>Location</th>
              <th style={{ textAlign: "right", paddingRight: "40px !important" }}>
                Quantity ({selectedItem?.unit?.unitName || ""})
              </th>
              <th className="verified-date-col">Verified Date (By)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {paginatedList?.length > 0 ?
              paginatedList?.map((x: any) => (
                <tr key={x.locationId}>
                  <td>{x.location.locationName}</td>
                  <td style={{ textAlign: "right", paddingRight: "40px !important" }}>
                    {parseFloat(x?.quantity?.toString()).toFixed(2)}
                  </td>
                  <td className="verified-date-col">{`${x?.verifyDate ? moment(x.verifyDate).format("MM/DD/YYYY") : "-"} ${x.user ? `(${x.user.userName})` : ""}`}</td>
                  <td>
                    <Dropdown>
                      <Dropdown.Toggle variant="link" id="dropdown-basic">
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={threedotvertical}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {isReceivePermitted && (
                          <Dropdown.Item
                            onClick={() => {
                              setActiveLocation(x.location.id);
                              toggleInventoryreceiveModal();
                            }}
                          >
                            Receive
                          </Dropdown.Item>
                        )}
                        {isAdjustPermitted && (
                          <Dropdown.Item
                            onClick={() => {
                              setActiveLocation(x.location.id);
                              toggleInventoryAdjustModal();
                            }}
                          >
                            Adjust
                          </Dropdown.Item>
                        )}
                        {isTransferPermitted && (
                          <Dropdown.Item
                            onClick={() => {
                              setActiveLocation(x.location.id);
                              toggleInventoryTransferModal();
                            }}
                          >
                            Transfer
                          </Dropdown.Item>
                        )}
                        {isRepackPermitted && (
                          <Dropdown.Item
                            onClick={() => {
                              setActiveLocation(x.location.id);
                              toggleInventoryrepackModal();
                            }}
                          >
                            Repack
                          </Dropdown.Item>
                        )}
                        {isUpdateCountPermitted && (
                          <Dropdown.Item
                            onClick={() => {
                              setActiveLocation(x.location.id);
                              toggleInventoryCountModal();
                            }}
                          >
                            Count
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={4} className="text-center py-3">
                    No Data Available.
                  </td>
                </tr>
              )
            }
            <tr>
              <th>Total</th>
              <th style={{ textAlign: "right", paddingRight: "40px !important" }}>{getTotal()}</th>
              <th></th>
              <th></th>
            </tr>
          </tbody>
        </Table>
      </div>

      {inventoryLocationGridPageSize && (inventoryCountList?.length || 0) > 0 && (
        <CommonPagination
          totalRecords={inventoryCountList?.length || 0}
          perPage={inventoryLocationGridPageSize}
          onChange={handlePaginationChange}
          currPageRecordCount={paginatedList?.length}
          currentPage={currentPage}
        />
      )}

      {showInventoryReceiveModal && (
        <InventoryReceiveModel
          locationDropDownVal={locationDropDownVal}
          selectedItem={selectedItem}
          selectCurrentUserId={currentUserId}
          toggleInventoryreceiveModal={toggleInventoryreceiveModal}
          inventoryTransactionsList={inventoryTransactionsList}
          invTransReceive={invTransReceive}
          activeLocation={activeLocation}
          requiredDecimalPoint={requiredDecimalPoint}
        />
      )}

      {showInventoryRepackModal && (
        <InventoryRepackModel
          locationDropDownVal={locationDropDownVal}
          selectedItem={selectedItem}
          selectCurrentUserId={currentUserId}
          toggleInventoryrepackModal={toggleInventoryrepackModal}
          invTransRepack={invTransRepack}
          activeLocation={activeLocation}
          requiredDecimalPoint={requiredDecimalPoint}
        />
      )}

      {showInventoryCountModal && (
        <InventoryCountModel
          locationDropDownVal={locationDropDownVal}
          selectedItem={selectedItem}
          selectCurrentUserId={currentUserId}
          toggleInventoryCountModal={toggleInventoryCountModal}
          invTransCount={invTransCount}
          inventoryTransactionsList={inventoryTransactionsList}
          inventoryCountList={inventoryCountList}
          activeLocation={activeLocation}
          requiredDecimalPoint={requiredDecimalPoint}
        />
      )}

      {showInventoryAdjustModal && (
        <InventoryAdjustModel
          locationDropDownVal={locationDropDownVal}
          selectedItem={selectedItem}
          selectCurrentUserId={currentUserId}
          toggleInventoryAdjustModal={toggleInventoryAdjustModal}
          inventoryTransactionsList={adjustmentTransactionList}
          invTransAdjust={invTransAdjust}
          activeLocation={activeLocation}
          requiredDecimalPoint={requiredDecimalPoint}
        />
      )}

      {showInventoryTransferModal && (
        <InventoryTransferModel
          locationDropDownVal={locationDropDownVal}
          selectedItem={selectedItem}
          selectCurrentUserId={currentUserId}
          toggleInventoryTransferModal={toggleInventoryTransferModal}
          inventoryTransactionsList={inventoryTransactionsList}
          invTransTransfer={invTransTransfer}
          activeLocation={activeLocation}
          requiredDecimalPoint={requiredDecimalPoint}
        />
      )}
    </>
  );
};
